import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import Contact from '../../home/components/Contact';
import WhatsAppDiagnostic from '../../home/components/WhatsAppDiagnostic';

export default function EntretienFenetresPVCLyon() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-600 via-cyan-500 to-teal-400 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-brush-2-line text-white"></i>
              <span className="text-white text-sm font-medium">Guide Entretien 2025</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
              Entretien Fenêtres PVC Lyon
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Guide complet pour entretenir vos fenêtres PVC à Lyon. Conseils pratiques, produits recommandés et fréquence d'entretien pour prolonger leur durée de vie.
            </p>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Entretien Fenêtres PVC Lyon : Guide Complet
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Les fenêtres PVC sont réputées pour leur facilité d'entretien. Contrairement au bois qui nécessite un entretien régulier, le PVC demande peu d'attention. Cependant, un entretien minimal et régulier permet de prolonger leur durée de vie jusqu'à 30-40 ans et de maintenir leurs performances optimales.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Pourquoi Entretenir ses Fenêtres PVC ?
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Prolonger la durée de vie :</strong> Un entretien régulier peut ajouter 10 ans à vos fenêtres</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Maintenir les performances :</strong> Isolation thermique et phonique optimales</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Préserver l'esthétique :</strong> PVC blanc éclatant sans jaunissement</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Éviter les réparations coûteuses :</strong> Détection précoce des problèmes</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Garantir le bon fonctionnement :</strong> Ouverture et fermeture fluides</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Fréquence d'Entretien Recommandée
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-calendar-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Nettoyage des profilés :</strong> 2 fois par an (printemps et automne)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-calendar-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Nettoyage des vitres :</strong> 4 fois par an minimum</span>
              </li>
              <li className="flex items-start">
                <i className="ri-calendar-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Lubrification des mécanismes :</strong> 1 fois par an</span>
              </li>
              <li className="flex items-start">
                <i className="ri-calendar-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Vérification des joints :</strong> 1 fois par an</span>
              </li>
              <li className="flex items-start">
                <i className="ri-calendar-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Nettoyage des rails :</strong> 2 fois par an</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Nettoyage des Profilés PVC
            </h3>
            
            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Produits Recommandés
            </h4>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Eau savonneuse :</strong> Savon de Marseille ou liquide vaisselle doux</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Nettoyant PVC spécifique :</strong> Disponible en magasin de bricolage (5-10€)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Vinaigre blanc dilué :</strong> Pour les taches tenaces (1 volume vinaigre, 2 volumes eau)</span>
              </li>
            </ul>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Produits à Éviter Absolument
            </h4>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-close-line text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Acétone et solvants :</strong> Attaquent le PVC et le décolorent</span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-line text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Produits abrasifs :</strong> Rayent la surface du PVC</span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-line text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Éponges grattantes :</strong> Créent des micro-rayures</span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-line text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Javel pure :</strong> Jaunit le PVC blanc</span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-line text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Nettoyeur haute pression :</strong> Risque d'infiltration d'eau</span>
              </li>
            </ul>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Méthode de Nettoyage
            </h4>
            
            <ol className="space-y-3 mb-6 list-decimal list-inside">
              <li className="text-gray-700">Préparez une solution d'eau tiède savonneuse</li>
              <li className="text-gray-700">Utilisez une éponge douce ou un chiffon microfibre</li>
              <li className="text-gray-700">Nettoyez les profilés de haut en bas</li>
              <li className="text-gray-700">Insistez sur les angles et les joints</li>
              <li className="text-gray-700">Rincez à l'eau claire</li>
              <li className="text-gray-700">Séchez avec un chiffon doux pour éviter les traces</li>
            </ol>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Entretien des Joints d'Étanchéité
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Les joints assurent l'étanchéité et l'isolation de vos fenêtres. Leur entretien est crucial à Lyon où les variations climatiques sont importantes.
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Nettoyage :</strong> Eau savonneuse avec une brosse douce, 2 fois par an</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Vérification :</strong> Contrôlez l'absence de fissures ou de déformation</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Remplacement :</strong> Tous les 10-15 ans ou dès les premiers signes d'usure</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Signes d'usure :</strong> Courants d'air, condensation, bruit extérieur accru</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Lubrification des Mécanismes
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Une lubrification annuelle garantit le bon fonctionnement de vos fenêtres PVC :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-tools-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Poignées :</strong> Huile 3-en-1 ou spray silicone sur les axes</span>
              </li>
              <li className="flex items-start">
                <i className="ri-tools-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Crémones :</strong> Graisse silicone sur les points de fermeture</span>
              </li>
              <li className="flex items-start">
                <i className="ri-tools-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Charnières :</strong> Quelques gouttes d'huile fine</span>
              </li>
              <li className="flex items-start">
                <i className="ri-tools-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Rails coulissants :</strong> Spray silicone après nettoyage</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Nettoyage des Rails et Évacuation d'Eau
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Les rails et orifices d'évacuation doivent être nettoyés régulièrement pour éviter les blocages :
            </p>

            <ol className="space-y-3 mb-6 list-decimal list-inside">
              <li className="text-gray-700">Passez l'aspirateur dans les rails pour retirer poussière et débris</li>
              <li className="text-gray-700">Nettoyez avec une brosse à dents et de l'eau savonneuse</li>
              <li className="text-gray-700">Vérifiez les orifices d'évacuation d'eau (petits trous en bas du cadre)</li>
              <li className="text-gray-700">Débouchez-les avec un fil de fer fin si nécessaire</li>
              <li className="text-gray-700">Rincez à l'eau claire et séchez</li>
            </ol>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Entretien Spécifique au Climat Lyonnais
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              À Lyon, certaines précautions supplémentaires sont recommandées :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-sun-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Été :</strong> Nettoyez après les orages pour retirer poussière et pollen</span>
              </li>
              <li className="flex items-start">
                <i className="ri-snowy-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Hiver :</strong> Vérifiez l'étanchéité avant les grands froids</span>
              </li>
              <li className="flex items-start">
                <i className="ri-windy-line text-teal-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Pollution :</strong> Nettoyage plus fréquent en centre-ville (3-4 fois/an)</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Quand Faire Appel à un Professionnel ?
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-alert-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Difficultés d'ouverture/fermeture :</strong> Réglage nécessaire</span>
              </li>
              <li className="flex items-start">
                <i className="ri-alert-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Courants d'air persistants :</strong> Remplacement de joints</span>
              </li>
              <li className="flex items-start">
                <i className="ri-alert-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Condensation entre les vitres :</strong> Vitrage défaillant</span>
              </li>
              <li className="flex items-start">
                <i className="ri-alert-line text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Mécanismes cassés :</strong> Remplacement de quincaillerie</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Conclusion
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              L'entretien des fenêtres PVC est simple et rapide. Avec seulement 2 heures par an, vous prolongez leur durée de vie de 10 ans et maintenez leurs performances optimales. À Lyon, un entretien régulier est d'autant plus important en raison de la pollution urbaine et des variations climatiques. N'hésitez pas à faire appel à un professionnel pour les opérations plus techniques.
            </p>
          </article>
        </div>
      </section>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      {/* Contact */}
      <Contact />
      
      <Footer />
    </div>
  );
}
